import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core'
import { setContext } from '@apollo/client/link/context'
import { TransportationTypes } from '@/utils/transportTypes'
import { getBearerToken } from '@/utils/auth'

const httpLink = createHttpLink({
  uri: '/graphql'
})

function toNormalForm (value: any): string {
  if (typeof value === 'boolean') value = value.toString()
  if (typeof value === 'number') value = value.toString()

  if (typeof value === 'string') {
    return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  }

  return ''
}

const authLink = setContext((_, { headers }) => {
  const bearerToken = getBearerToken()

  return {
    headers: {
      ...headers,

      ...(bearerToken && {
        authorization: bearerToken
      }),

      outletid: toNormalForm(localStorage.getItem('shipToId')),

      datepopup: toNormalForm(
        localStorage.getItem('deliveryDate')
      ),

      standarddeliverydate:
        localStorage.getItem('shippingMethod') === 'posm_posm'
          ? 1
          : toNormalForm(
            localStorage.getItem('standardDeliveryDate')
          ),

      store: toNormalForm(
        localStorage.getItem('store')
      ),

      outletdeliverymethod: toNormalForm(
        localStorage.getItem('shippingMethod')
      ),

      onlyEmpties: toNormalForm(
        localStorage.getItem('onlyEmpties')
      ),

      noteForDriver: toNormalForm(
        localStorage.getItem('noteForDriver')
      ),

      customerOrderNumber: toNormalForm(
        localStorage.getItem('customerOrderNumber')
      ),

      lang: toNormalForm(
        localStorage.getItem('lang')
      ),

      customertype: toNormalForm(
        localStorage.getItem('customertype')
      ),

      productrecoenabled: toNormalForm(
        localStorage.getItem('productrecoenabled')
      ),

      cartSKUs: toNormalForm(
        localStorage.getItem('cartSKUs')
      ),

      exceptiondate: toNormalForm(
        localStorage.getItem('exceptiondate') ?? 0
      ),

      onlyUnfiltered:
        localStorage.getItem('shippingMethod') ===
        TransportationTypes.UNFILTERED
          ? 1
          : 0,

      onlyTank:
        localStorage.getItem('shippingMethod') ===
        TransportationTypes.TANK
          ? 1
          : 0,

      onlyPOSM:
        localStorage.getItem('shippingMethod') ===
        TransportationTypes.POSM
          ? 1
          : 0
    }
  }
})
const cache = new InMemoryCache()

export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache'
    },
    query: {
      fetchPolicy: 'no-cache'
    }
  }
})
